module.exports = __webpack_public_path__ + "static/media/laurenSmith.5224bd0e.png";